import { Route, Routes, useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import { useEffect, useLayoutEffect, useState } from "react";
import Splash from "../../pages/Splash";
import AuthLayout from "../../layouts/AuthLayout";
import ContributerLayout from "../../layouts/ContributerLayout";
import UserLayout from "../../layouts/UserLayout";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { userLogin } from "../../redux/action";
import { TbSquareChevronsDownFilled } from "react-icons/tb";
import { logoutUser } from "../../apis/AuthApis";
import { getProfile } from "../../apis/UserProfile";

/**gets the routes and layout based on user param  */
export const getRoutesAndLayout = (user) => {
  let type = Array.isArray(user?.roles) ? user?.roles[0] : "";
  switch (type) {
    case "user":
      return {
        routesAvailable: routes?.userRoutes,
        Layout: UserLayout,
        commonRoutes: routes?.commonRoutes,
      };
    case "contributor":
      return {
        routesAvailable: routes?.contributerRoutes,
        Layout: ContributerLayout,
        commonRoutes: routes?.commonRoutes,
      };

    default:
      console.log("this case is working", type);
      return { routesAvailable: routes?.authRoutes, Layout: AuthLayout };
  }
};

const AppRoutes = () => {
  const user = useSelector((s) => s?.user ?? {}, shallowEqual);
  console.log("user res===>", user);
  const { Layout, routesAvailable, commonRoutes } = getRoutesAndLayout(user);
  const [checkState,setCheckState]=useState(true);

  const navigateTo = useNavigate();
  const dispatch = useDispatch();

  //listen for user-logout call
  useEffect(() => {
    const listener = () => {
      navigateTo("/");
    };
    window?.addEventListener("user-logout", listener);
    return () => window?.removeEventListener("user-logout", listener);
  }, []);

  useLayoutEffect(() => {
    //call api here and dispatch the user

    const fetchData = async () => {
      try {
        const userProfile = await getProfile();
        if (userProfile?.data?.user) {
          dispatch(userLogin(userProfile?.data?.user));
        }
        setCheckState(false);
      } catch (error) {
        console.log("Errro Fetching Profile====>", error);
        setCheckState(false);
      }
    };
    fetchData();
  }, []);

  const clearLogoutData = () => {
    logoutUser({}, (e) => {
      console.error(e);
    })
      .then(() => {
        dispatch(userLogin(null));
        localStorage.clear();
        navigateTo("/");
      })
      .catch(() => {});
  };

  return (
    <Routes>
      {checkState?(<>
        <Route path={"/"} element={<Splash />} />
          <Route path={"*"} element={<Splash />} />
      </>):
      user === null ? (
        <>
          <Route path={"/"} element={<Splash />} />
          <Route path={"*"} element={<Splash />} />
        </>
      ) : (
        <Route
          path="/"
          element={
            <Layout
              // onLogout={() => {
              //   dispatch(userLogin(null));
              //   localStorage.clear();
              //   navigateTo("/");
              // }}
              onLogout={clearLogoutData}
            />
          }
        >
          {routesAvailable?.map((route) => {
            let Component = route?.component;
            return (
              <Route
                path={route?.path}
                element={
                  <Component
                    onAuthSuccess={(data) => {
                      console.log("data", data);

                      dispatch(userLogin(data));
                      navigateTo("/");
                    }}
                    // onLogout={() => {
                    //   dispatch(userLogin(null));
                    //   localStorage.clear();
                    //   navigateTo("/");
                    // }}
                    onLogout={clearLogoutData}
                  />
                }
              />
            );
          })}
          {commonRoutes?.map((route) => {
            let Component = route?.component;
            return (
              <Route
                path={route?.path}
                element={
                  <Component
                    onAuthSuccess={() => {
                      navigateTo("/");
                    }}
                    // onLogout={() => {
                    //   dispatch(userLogin(null));
                    //   localStorage.clear();
                    //   navigateTo("/");
                    // }}
                    onLogout={clearLogoutData}
                  />
                }
              />
            );
          })}
        </Route>
      )}
    </Routes>
  );
};

export default AppRoutes;
